// Live countdown + expiry helpers
export function getRemaining(expiresAt) {
  if (!expiresAt) return { expired: false, label: "" };
  const end = new Date(expiresAt).getTime();
  const diff = end - Date.now();
  if (diff <= 0) return { expired: true, label: "Expired", d: 0, h: 0, m: 0, s: 0 };
  const s = Math.floor(diff / 1000);
  const d = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  let label;
  if (d > 0) label = `${d}d ${h}h left`;
  else if (h > 0) label = `${h}h ${m}m left`;
  else label = `${m}m ${sec}s left`;
  return { expired: false, label, d, h, m, s: sec };
}

// Localised countdown text. Pass the t() helper from LanguageContext.
export function remainingLabel(rem, t) {
  if (!rem || rem.label === "") return "";
  if (rem.expired) return t("time.expired");
  if (rem.d > 0) return t("time.dLeft", { d: rem.d, h: rem.h });
  if (rem.h > 0) return t("time.hLeft", { h: rem.h, m: rem.m });
  return t("time.mLeft", { m: rem.m, s: rem.s });
}

export function isLive(deal) {
  if (!deal || !deal.expiresAt) return true;
  return new Date(deal.expiresAt).getTime() > Date.now();
}
